// extracted by mini-css-extract-plugin
export var categoryMenu = "CategoryMenu-module--categoryMenu--3G0lw";
export var categoryMenu__current = "CategoryMenu-module--categoryMenu__current--13ybq";